export const palette = {
  transparent: 'transparent',
  watermelon: '#e5174e',
  strawberry: '#e21a8c',
  fuschia: '#cc32af',
  plum: '#a00385',
  wisteria: '#9f12b7',
  eggplant: '#6d09a8',
  indigo: '#1009a8',
  denim: '#005293',
  cerulean: '#00a9e0',
  marine: '#00d8dd',
  seafoam: '#30c6be',
  jungle: '#00b092',
  fern: '#09a84c',
  lime: '#69be28',
  shamrock: '#a0bc2a',
  spring: '#dad648',
  dandelion: '#fed648',
  sunglow: '#eaab00',
  copper: '#ca7700',
  mango: '#ea6c02',
  tangerine: '#e8490a',
  sunset: '#d52101',
  mahogany: '#b50200',
  mulberry: '#7c2348',
  beaver: '#755954',
  tumbleweed: '#ba9c61',
  pewter: '#a49ca1',
  graphite: '#6b6268',
  iron: '#564c51',
  charcoal: '#3d3236',
  paper: '#ffffff',
  ghost: '#edf2f9',
  pale: '#dde2e9',
  dove: '#c4cacd',
  heather: '#b7bcc4',
  fog: '#a0a6a9',
  slate: '#888e90',
  aluminum: '#878c94',
  shadow: '#767b7e',
  shuttle: '#61666e',
  forge: '#474c54',
  gunmetal: '#31363e',
  midnight: '#272c34',
  obsidian: '#000000',

  chrome50: '#e6f0f4',
  chrome100: '#c3d8e4',
  chrome200: '#9fc5d5',
  chrome500: '#438098',
  chrome600: '#336275',
  chrome700: '#244451',
  chrome800: '#14262e',

  primary200: '#86e0ed',
  primary300: '#5cd5e5',
  primary400: '#30cade',
  primary500: '#1eaabd',
  primary700: '#0f5a65',

  DeepOrange50: '#ffffff',
  DeepOrange100: '#fff2ee',
  DeepOrange200: '#ffcbbb',
  DeepOrange300: '#ffa588',
  DeepOrange400: '#ff7e55',
  DeepOrange500: '#FF5722',
  DeepOrange600: '#ee3900',
  DeepOrange700: '#bb2d00',
  DeepOrange800: '#882100',
  DeepOrange900: '#551400',
  DeepOrange1000: '#220800',
};
